module.exports = __webpack_public_path__ + "static/media/ice35.e84bc920.webp";